import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import SuperTokens, { SuperTokensWrapper } from "supertokens-auth-react";
import { SuperTokensConfig } from "./supertokensConfig";
import { GlobalErrorProvider } from "./context/GlobalErrorContext";

// Set the base URL for all axios requests
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:5000";
console.log("Connecting to backend at: ", axios.defaults.baseURL);
console.log("Connecting to supertokens at: ", SuperTokensConfig.appInfo.apiDomain);


SuperTokens.init(SuperTokensConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <SuperTokensWrapper>
            <GlobalErrorProvider>
                <App />
            </GlobalErrorProvider>
        </SuperTokensWrapper>
    </React.StrictMode>
);
